/* eslint-disable compat/compat */
'use strict';

const $ = require('jquery');
const dates = require('util/date');

const orderBy = require('lodash/orderBy');
const assign = require('lodash/assign');
const get = require('lodash/get');
const isEmpty = require('lodash/isEmpty');

const cookies = require('js-cookie');

// We'll be using really crude caching here. We could use memoize but why get a fat function
// when you can just do the same in vanilla JS with a few lines
const cache = {};

// Are we developing?
const is_developing = get(window, 'is_developing', false);

module.exports = ['$http', '$sce', 'appConfig', ($http, $sce, appConfig) => {
    // Load performances from endpoint

    const today = dates.moment();

    function loadPerformances() {
        if ('loadPerformances' in cache) {
            return cache.loadPerformances;
        }

        let options = {
            cache: true,
        }

        if (is_developing) {
            options.headers = {
                Authorization: 'Basic cHJldmlldzpwcmV2aWV3',
            };
        }

        let url = appConfig.eventsFeedUrl;

        let session = cookies.get('real_mos');

        if (!isEmpty(session)) {
            try {
                session = JSON.parse(session);

                if (get(session, 'mos', null) && get(session, 'promo_code', null) && get(session, 'source_no', null)) {
                    url = `${url}?mos=${session.mos}&source=${session.source_no}`;
                } else if (get(session, 'mos', null)) {
                    url = `${url}?mos=${session.mos}`;
                }
            } catch (parseError) {
                // Do nothing
            }
        }

        if (appConfig.exchangePriceTypesFeedUrl) {
            $.ajax({
                url: appConfig.exchangePriceTypesFeedUrl,
                type: "GET",
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function (response) {
                    if (response.available_price_types && response.available_price_types.length > 0 && response.available_price_types[0]) {
                        // There are exchange price types in basket, get availability only with first price type
                        url = `${url}&price_types=${response.available_price_types[0]}`;
                    }
                },
                async: false
            });
        }

        cache.loadPerformances = $http.get(url, options).then(response => {
            const hour = dates.moment().startOf('hour');

            return response.data.filter(performance => {
                return dates.moment(performance.start_date).isAfter(hour);
            });
        });

        return cache.loadPerformances;
    }

    // Get performances is just an alias
    function getPerformances() {
        if ('getPerformances' in cache) {
            return cache.getPerformances;
        }

        cache.getPerformances = loadPerformances().then(response => {
            // Do some management
            let performances = response.map(performance => {
                performance.start_date = performance.start_date.substring(0, 19);
                performance.end_date = performance.end_date.substring(0, 19);
                performance.has_promo = performance.prices.filter(priceType => priceType.price_type_category === 'Discount' && parseInt(priceType.avail_count) > 0).length > 0;

                // Momentise some dates for ease of use after
                performance.start_date_moment = dates.moment(performance.start_date);
                performance.end_date_moment = dates.moment(performance.end_date);
                performance.on_sale_date_moment = dates.moment(performance.on_sale_date);
                performance.off_sale_date_moment = dates.moment(performance.off_sale_date);
                const inPast = performance.start_date_moment.isBefore(today);
                const isEvening = performance.start_date_moment.hours() >= 19;

                performance.inPast = inPast;

                performance.date_formats = {
                    ticket__short_day: performance.start_date_moment.format('ddd'),
                    ticket__day: performance.start_date_moment.format('dddd'),
                    ticket__month: performance.start_date_moment.format('MMMM'),
                    ticket__dayofmonth: performance.start_date_moment.format('D'),
                    ticket__year: performance.start_date_moment.format('Y'),
                    ticket__time: performance.start_date_moment.format('h:mma'),
                    ticket__icon: (isEvening) ? 'moon' : 'sun',
                    ticket__period: (isEvening) ? 'evening' : 'matinee'
                };

                let timeAriaLabel = (isEvening) ? 'svgMoonIcon' : 'svgSunIcon';
                let timeAltText = (isEvening) ? 'Shape of the moon' : 'Shape of the sun';

                performance.ticket_span_short = $sce.trustAsHtml(`
                <div class="ticket__date">
                    <span class="ticket__time-icon ticket__time-icon--${performance.date_formats.ticket__period}">
                        <svg class="o-icon " aria-hidden="true" aria-labelledby="${timeAriaLabel}">
                        <title id="${timeAriaLabel}">${timeAltText}</title>
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-${performance.date_formats.ticket__icon}"></use>
                        </svg>
                    </span>
                    <span class="ticket__time">${performance.date_formats.ticket__time}</span>
                </div>
                `);

                performance.ticket_span_short_date = $sce.trustAsHtml(`
                <div>
                    <span class="ticket__shortday">${performance.date_formats.ticket__short_day}</span>
                    <strong>
                        <span class="ticket__month">${performance.date_formats.ticket__month}</span>
                        <span class="ticket__dayofmonth">${performance.date_formats.ticket__dayofmonth}</span>
                    </strong>
                </div>
                `);

                performance.ticket_span = $sce.trustAsHtml(`
                <div class="ticket__date">
                    <span class="ticket__time-icon ticket__time-icon--${performance.date_formats.ticket__period}">
                        <svg class="o-icon " aria-hidden="true" aria-labelledby="${timeAriaLabel}">
                        <title id="${timeAriaLabel}">${timeAltText}</title>
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-${performance.date_formats.ticket__icon}"></use>
                        </svg>
                    </span>
                    <span class="ticket__day">${performance.date_formats.ticket__day}</span>,
                    <span class="ticket__month">${performance.date_formats.ticket__month}</span>
                    <span class="ticket__dayofmonth">${performance.date_formats.ticket__dayofmonth}</span>,
                    <span class="ticket__year">${performance.date_formats.ticket__year}</span>
                    <span class="ticket__time-container">
                        at <span class="ticket__time">${performance.date_formats.ticket__time}</span>
                    </span>
                </div>
                `);

                // On sale dates are tricky
                if (performance.initial_on_sale_date) {
                    performance.initial_on_sale_date_moment = dates.moment(performance.initial_on_sale_date);
                } else {
                    performance.initial_on_sale_date_moment = performance.on_sale_date_moment.clone();
                }

                if (performance.initial_off_sale_date) {
                    performance.initial_off_sale_date_moment = dates.moment(performance.initial_off_sale_date);
                } else {
                    performance.initial_off_sale_date_moment = performance.off_sale_date_moment.clone();
                }

                // Is it _actually_ sold out?
                performance.is_sold_out = get(performance, 'performance_availability_status.label', false) === 'Sold Out';

                // Generate flags
                const theatrePlus = performance.facets.filter(item => {
                    return item.category === 'Theatre-Plus';
                });

                // mark
                performance.types = [];
                for (var i = 0; i < appConfig.performanceTypes.length; i++) {
                    performance.types[appConfig.performanceTypes[i].id] = theatrePlus.some(item => {
                        return (
                            (
                                item.keyword === appConfig.performanceTypes[i].keyword
                            ) ||
                            (
                                item.category === 'Web Calendar' &&
                                item.keyword === appConfig.performanceTypes[i].keyword &&
                                appConfig.performanceTypes[i].keyword === 'Relaxed Performance'
                            )
                        );
                    });
                }

                performance.is_series = performance.types.some(item => {
                    return item === true;
                });

                // Return the updated item
                return performance;
            });

            // Sort by start date & return
            return orderBy(performances, item => item.start_date_moment.valueOf());
        });

        return cache.getPerformances;
    };

    function getPerformancesByPrices() {
        if ('getPerformancesByPrices' in cache) {
            return cache.getPerformancesByPrices;
        }

        cache.getPerformancesByPrices = getPerformances().then(response => {
            response = response.reduce((carry, performance) => {
                let items = performance.prices.filter(price => {
                    return price.available === 'Y';
                });

                items = items.map(price => {
                    return assign({}, performance, {
                        avail_count: parseInt(price.avail_count, 10),
                        price: parseFloat(price.price).toFixed(2),
                        price_desc: price.price_desc,
                        price_zone: price.description,
                    });
                });

                return [].concat(carry, items);
            }, []);

            response = response.filter(performance => {
                return !performance.is_sold_out && performance.avail_count > 0 && performance.price > 0;
            });

            // Sort by start date & return
            return orderBy(response, item => item.start_date_moment.valueOf());
        });

        return cache.getPerformancesByPrices;
    }

    function checkPromoCode(code) {
        let url = appConfig.ticketingEndpoint + '/api/v2/validate-promocode/' + code

        return $http.get(url, {});
    }

    function removePromoCode() {
        return $http.get(
            `${appConfig.ticketingEndpoint}/api/promocode/remove`,
            {
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                }
            }
        );
    }

    function addPromoCode(code) {
        return $http.get(
            `${appConfig.ticketingEndpoint}/api/promocode/add/${code}`,
            {
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                }
            }
        );
    }

    return {
        getPerformances: getPerformances,
        getPerformancesByPrices: getPerformancesByPrices,
        checkPromoCode: checkPromoCode,
        removePromoCode: removePromoCode,
        addPromoCode: addPromoCode,
    }
}];



// WEBPACK FOOTER //
// ./widgets/services/inventoryService.js